import { clearIrmData } from './onClearMsgPermissions';
import protectMessageAndRemoveAddin from 'owa-mail-compose-actions/lib/utils/protectMessageAndRemoveAddin';
import type { ComposeViewState } from 'owa-mail-compose-store';
import clearClassification from 'owa-mail-protection/lib/utils/classification/clearClassification';

export default function onToggleRMSTemplate(
    viewState: ComposeViewState,
    RmsTemplateId: string,
    targetWindow: Window
) {
    const { protectionViewState } = viewState;
    const { classificationViewState, IRMData } = protectionViewState;

    clearClassification(classificationViewState, viewState);
    if (IRMData && IRMData.RmsTemplateId === RmsTemplateId) {
        clearIrmData(viewState, IRMData);
    } else {
        protectMessageAndRemoveAddin(viewState, RmsTemplateId, targetWindow);
    }
}
